import React from 'react'

export default props => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill={props.fill} fillRule="nonzero">
        <path d="M12.783 21.17a29.155 29.155 0 0 0 2.991-2.733C18.427 15.637 20 12.753 20 10a8 8 0 0 0-16 0c0 2.753 1.573 5.636 4.226 8.437A29.155 29.155 0 0 0 12 21.773c.242-.18.505-.38.783-.602zm4.443-1.357a31.132 31.132 0 0 1-4.254 3.726c-.195.141-.337.24-.417.293a1 1 0 0 1-1.11 0c-.08-.054-.222-.152-.417-.293a31.132 31.132 0 0 1-4.254-3.726C3.802 16.676 2 13.372 2 10 2 4.477 6.477 0 12 0s10 4.477 10 10c0 3.372-1.802 6.676-4.774 9.813zM12 14a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
    </svg>
)
